// extracted by mini-css-extract-plugin
module.exports = {"container":"EntryInPendingState_container__V0LGe","svg":"EntryInPendingState_svg__Ze7xY"};